<template>
	<div>
		<div class="ma-6">
			<div @mousedown="startDrag"  @mouseup="handleDrag" id="map"></div>
		</div>
		<Loading v-if="loading" />
		<!-- <button class="save-info">Test</button> -->
	</div>
</template>
<script>
import mapboxgl from 'mapbox-gl';
import axios from 'axios';
import Loading from '../../components/Loading/index.vue';

export default {
	name: 'MapboxMap',
	components: {
        Loading
    },
	props: {
    defaultLat: {
      type: String,
      default: null
    },
    defaultLng: {
      type: String,
      default: null
    }
  },
	data() {
		// Set initial data, this.createMap() configures event listeners that update data based on user interaction
		return {
			center: { lat: this.defaultLat || "35.768032", lng: this.defaultLng || "51.418596" },
			zoom: 14,
			loading: false,
			isDragging: false,
		};
	},
	mounted() {
		if (mapboxgl.getRTLTextPluginStatus() !== 'loaded') {
			mapboxgl.accessToken =
				'pk.eyJ1IjoiY2FycGllY2UiLCJhIjoiY2xyN24xYjJ6MmE0ZzJrdGFoZHRlM2ltZiJ9.2vf2qfWKQUZmnW-tj46peg';
			mapboxgl.setRTLTextPlugin(
				'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
				null,
				true, // Lazy load the plugin
			);
		}
		(window.history);
		// create the map after the component is mounted
		this.createMap();
	},
	methods: {
		startDrag() {
			this.isDragging = true;
		},
		handleDrag() {
            this.loading = true
			if (this.isDragging) {
				setTimeout(() => {
					this.onClick();
				}, 1000);
			}
		},
		endDrag() {
			this.isDragging = false;
		},
		async onClick() {
			await axios
				.get('https://map.ir/reverse/fast-reverse', {
					headers: {
						'x-api-key':
							'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjJlYzQ5Y2JmZTM5MGE2N2U1ZjEzYmIwZTgwOWQ4NGQzZDY1N2I3YTFiZDc4MmE4NzRkODM4ZjQ1OGJhYzg2OGRiZWQzMjI1ZjEzYzQ1ZmU2In0.eyJhdWQiOiIxNzk4OCIsImp0aSI6IjJlYzQ5Y2JmZTM5MGE2N2U1ZjEzYmIwZTgwOWQ4NGQzZDY1N2I3YTFiZDc4MmE4NzRkODM4ZjQ1OGJhYzg2OGRiZWQzMjI1ZjEzYzQ1ZmU2IiwiaWF0IjoxNjUyOTUwMDY0LCJuYmYiOjE2NTI5NTAwNjQsImV4cCI6MTY1NTU0MjA2NCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.RujbvEe-PwrGCQOHFaAs069J4H-oFhzDxEquC8cc4GNnsBysEDTbh5gon1_UjRWvwVZuuqpM3yLcZNdM18CS7Bt7_KOOPYUomE8vL4LIhl_hIpLK4Gj4YrYhN-ixle2uPxpcJfoVDNvyiBzjBBWBGKqhBgKDD1GCg92Zdj8QahzqEN3HTnYupeakhAi9Srack09Wb8dlKjY8ZUSPLKFbhBrSiEh0-uYtecJIvggirWms5SZrjBaCJ9KvYS0INh7Mj6PUlSH8HiZZp-khjMkziB-vtrTmm14-G1FIUPkqOH9v_Ez8MJAb0CYA2L0ti8rVVYPfDWLTdNiLlYQVpLnvfQ',
					},
					params: {
						lat: `${this.center.lat}`,
						lon: `${this.center.lng}`,
					},
				})
				.then((res) => {
					(res);
					if (res.status === 200) {
						('ads', res);
						const dataToSend = res.data;
						this.$emit('child-event', dataToSend);
                        this.loading = false;
					}
				});
		},
		createMap() {
			// instantiate map.  this method runs once after the vue component is mounted to the dom
			this.map = new mapboxgl.Map({
				accessToken:
					'pk.eyJ1IjoiY2FycGllY2UiLCJhIjoiY2xyN24xYjJ6MmE0ZzJrdGFoZHRlM2ltZiJ9.2vf2qfWKQUZmnW-tj46peg',
				container: 'map',
				style: 'mapbox://styles/mapbox/streets-v11',
				minZoom: 1,
				maxZoom: 18,
				center: this.center, // use initial data as default
				zoom: this.zoom,
			});
			const nav = new mapboxgl.GeolocateControl({
				positionOptions: {
					enableHighAccuracy: true,
				},
				// When active the map will receive updates to the device's location as it changes.
				trackUserLocation: true,
				// Draw an arrow next to the location dot to indicate which direction the device is heading.
				showUserHeading: true,
			});
			this.map.addControl(nav, 'bottom-left');
			var marker = new mapboxgl.Marker({ color: '#B05958' })
				.setLngLat(this.map.getCenter())
				.addTo(this.map);

			// set mapbox event listeners to update Vue component data
			this.map.on('move', () => {
				// set the vue instance's data.center to the results of the mapbox instance method for getting the center
				this.center = this.map.getCenter();
				marker.setLngLat(this.map.getCenter());
			});
			this.map.on('zoom', () => {
				// set the vue instance's data.zoom to the results of the mapbox instance method for getting the zoom
				this.zoom = this.map.getZoom();
			});
		},
	},
};
</script>

<style>
#map {
	width: 100%;
	height: 50vh;
	border-radius: 8px;
}
.mapboxgl-ctrl-icon {
	background-image: url('../../assets/images/myLocation.svg') !important;
	width: 100%;
	height: 100%;
	display: flex;
	margin: 8px -8px;
	padding: 0 !important;
}
.mapboxgl-ctrl-attrib.mapboxgl-compact {
	display: none !important;
}
.mapboxgl-ctrl-group > button {
	width: 40px;
	height: 40px;
}
.mapboxgl-ctrl-logo {
	display: none !important;
}
.mapboxgl-ctrl-geolocate {
    display: none !important;
}
</style>
